import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { forgotPassword } from '../service/UserService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await forgotPassword(email);
      setMessage('Se ha enviado un enlace de recuperación a tu email.');
      setError('');
    } catch (error) {
      setError(error.response?.data?.error || 'Error al enviar el email de recuperación.');
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex flex-column justify-content-center align-items-center login-center'>
        <form
          className='Login col-md-8 col-lg-4 col-11'
          onSubmit={submitHandler}
        >
          <h4 className='mb-4 text-center'>Recuperar Contraseña</h4>
          <p className='text-center mb-4' style={{ fontSize: '14px', color: '#7a7a7a' }}>
            Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
          </p>
          
          <input
            type='email'
            placeholder='Correo electrónico'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ fontWeigth: 'bold', color: 'black' }}
            className={error ? 'error-input' : ''}
            required
          />
          
          {error && (
            <div className='error-message'>
              <div className='d-flex align-items-start'>
                <i className='fas fa-exclamation-triangle me-2 mt-1' style={{ fontSize: '0.875rem' }}></i>
                <small className='flex-grow-1'>
                  {error}
                </small>
              </div>
            </div>
          )}

          {message && (
            <div className='alert alert-success my-3' role='alert' style={{ textAlign: 'left' }}>
              <div className='d-flex align-items-start'>
                <i className='fas fa-check-circle me-2 mt-1' style={{ fontSize: '0.875rem' }}></i>
                <small className='flex-grow-1'>
                  {message}
                </small>
              </div>
            </div>
          )}

          <button 
            type='submit' 
            disabled={loading || !email.trim()}
            style={{
              backgroundColor: (!email.trim() && !loading) ? 'grey' : undefined,
            }}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Enviando...
              </>
            ) : (
              <>
                <span className="d-none d-md-inline">Enviar enlace de recuperación</span>
                <span className="d-md-none">ENVIAR ENLACE</span>
              </>
            )}
          </button>
          
          <p className='text-center mt-3'>
            <Link to={'/login'} style={{ fontSize: '14px', color: '#7a7a7a' }}>
              Volver al inicio de sesión
            </Link>
          </p>
        </form>
      </div>
    </>
  );
};

export default ForgotPassword;
